import { render, staticRenderFns } from "./recoedDetails.vue?vue&type=template&id=36dfd856&scoped=true&"
import script from "./recoedDetails.vue?vue&type=script&lang=js&"
export * from "./recoedDetails.vue?vue&type=script&lang=js&"
import style0 from "./recoedDetails.vue?vue&type=style&index=0&id=36dfd856&prod&scoped=true&lang=css&"
import style1 from "./recoedDetails.vue?vue&type=style&index=1&id=36dfd856&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dfd856",
  null
  
)

export default component.exports